export default __webpack_public_path__ + "img/d453d41f141cc4aadb0ec6e4547aa254.svg";